import { Box, Stepper, Step, StepLabel } from '@mui/material'

const ORDER_STATUSES = [
  'draft',
  'confirmed',
  'ordered',
  'partially_received',
  'received',
  'allocated',
  'completed'
]

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  confirmed: 'Confirmed',
  ordered: 'Ordered',
  partially_received: 'Partial',
  received: 'Received',
  allocated: 'Allocated',
  completed: 'Completed'
}

interface OrderStatusBarProps {
  status: string
}

export default function OrderStatusBar({ status }: OrderStatusBarProps) {
  const activeStep = ORDER_STATUSES.indexOf(status)

  return (
    <Box sx={{ width: '100%', my: 2 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {ORDER_STATUSES.map((s) => (
          <Step key={s} completed={ORDER_STATUSES.indexOf(s) < activeStep}>
            <StepLabel>{STATUS_LABELS[s]}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
